<div class="seq" *ngIf="rowCount" role="dialog" aria-label="Which machine do these parts belong to?">
  <div class="seq__bar"></div>

  <div class="seq__head">
    <div class="seq__icon"><mat-icon>precision_manufacturing</mat-icon></div>
    <div>
      <div class="seq__title">Which machine do these parts belong to?</div>
      <div class="seq__sub">
        We read <b>{{ rowCount }}</b> spare part<span *ngIf="rowCount !== 1">s</span>
        <span *ngIf="fileName"> from <b>{{ fileName }}</b></span>.
        This list does not name the machine, so tell us once and it applies to every row.
      </div>
    </div>
  </div>

  <div class="seq__grid">
    <mat-form-field appearance="outline" class="seq__field">
      <mat-label>Equipment name *</mat-label>
      <input matInput [(ngModel)]="equipmentName" placeholder="e.g. Main Engine" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="seq__field">
      <mat-label>Maker / OEM *</mat-label>
      <input matInput [(ngModel)]="equipmentManufacturer" placeholder="e.g. Scania" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="seq__field">
      <mat-label>Model</mat-label>
      <input matInput [(ngModel)]="equipmentModel" placeholder="e.g. DI 16" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="seq__field">
      <mat-label>Serial number</mat-label>
      <input matInput [(ngModel)]="equipmentSerialNo" placeholder="identifies the installed unit" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="seq__field">
      <mat-label>SFI code</mat-label>
      <input matInput [(ngModel)]="sfiCode" placeholder="e.g. 601" />
    </mat-form-field>
  </div>

  <div class="seq__note">
    <mat-icon>info</mat-icon>
    <span>
      Maker and model are what a part number is checked against, so the same
      part number on a different machine is not treated as a duplicate.
    </span>
  </div>

  <div class="seq__actions">
    <button type="button" class="seq__btn seq__btn--ghost" (click)="cancel.emit()" [disabled]="busy">
      Cancel
    </button>
    <button type="button" class="seq__btn seq__btn--go" (click)="submit()" [disabled]="!canImport">
      <mat-icon>upload</mat-icon>
      {{ busy ? 'Importing…' : 'Import ' + rowCount + ' spare part' + (rowCount === 1 ? '' : 's') }}
    </button>
  </div>
</div>
